const prefix = '@Error/';

export default {
  ERROR: `${prefix}ERROR`,
  CLEAR_ERROR: `${prefix}CLEAR_ERROR`,
  CLEAR_ERROR_FROM_VIEW: `${prefix}CLEAR_ERROR_IN_VIEW`,
};
